const Hip_questions = [
   {
      "question":"How is ##name## being evaluated today?",
      "sub":"",
      "type":"radio",
      "telehealth":"form1[0].#subform[0].Public2507Questions[0].HowExamCOnducted[0]",
      "show": true,
      "section": {
         page: "1",
         title: "Disability Benefits Questionnaire",
         number: "0"
      },
      "questions":[
         {
            "label":"How was the examination conducted?",
            "title":"",
            "subMain":"",
            "sub":"",
            "radioGroup":"form1[0].#subform[0].Public2507Questions[0].RadioButtonList[2]",
            "options":[
               {
                  "main":"In-Person Exam",
                  "dbqName":"1",
                  "sub":""
               },
               {
                  "main":"Video Telehealth",
                  "dbqName":"2",
                  "sub":""
               }
            ],
            "answer":"In-Person Exam"
         }
      ]
   },
   {
      "question":"Is ##name## regularly seen as a patient in your clinic?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "1",
         title: "Disability Benefits Questionnaire",
         number: "0"
      },
      "presidence":"Yes",
      "radioGroup":"form1[0].#subform[0].Public2507Questions[0].RadioButtonList[1]",
      "ref":0,
      "dbqName_yes":"1",
      "dbqName_no":"2",
      "answer":"",
   },
   {
      "question":"Did you review any of the patients records for this condition?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "1",
         title: "EVIDENCE REVIEW",
         number: "0"
      },
      "presidence":"Yes",
      "maxLength":750,
      "radioGroup":"form1[0].#subform[0].PublicEvidenceReview[0].RadioButtonList[0]",
      "ref":0,
      "dbqName_yes":"2",
      "dbqName_no":"1",
      "answer":"",
      "istext": true,
      "textarea": false,
      "placeholder": "Please identify the evidence reviewed and the date range",
      "textdbqName":"form1[0].#subform[0].PublicEvidenceReview[0].IdentifyEvidence[0]",
      "textanswer":""
   },
   {
      "question":"ROM Measurements After Repetitive Use Testing for ##redHeading##",
      "redHeading": "Right Hip",
      "sub":"",
      "type":"text",
      "show": true,
      "section": {
         page: "3",
         title: "RANGE OF MOTION (ROM) AND FUNCTIONAL LIMITATION REVIEW",
         number: "3A"
      },
      "questions":[
         {
            "main":"Flexion",
            "subMain":"Normal Endpoint is 125 Degrees",
            "sub":"Post-Test ROM Measurement",
            "type":"select",
            "dbqName":"form1[0].#subform[5].TextField6[82]",
            "defaultVal":"125",
            "values":["125", "120", "115", "110", "105", "100", "95", "90", "85", "80", "75", "70", "65", "60", "55", "50", "45", "40", "35", "30", "25", "20", "15", "10", "5"],
            "answer":"125"
         },
         {
            "main":"Extension",
            "subMain":"Normal Endpoint is 30 Degrees",
            "sub":"Post-Test ROM Measurement",
            "type":"select",
            "dbqName":"form1[0].#subform[5].TextField6[83]",
            "defaultVal":"30",
            "values":["30", "25", "20", "15", "10", "5"],
            "answer":"30"
         },
         {
            "main":"Abduction",
            "subMain":"Normal Endpoint is 45 Degrees",
            "sub":"Post-Test ROM Measurement",
            "type":"select",
            "dbqName":"form1[0].#subform[5].TextField6[84]",
            "defaultVal":"45",
            "values":["45", "40", "35", "30", "25", "20", "15", "10", "5"],
            "answer":"45"
         },
         {
            "main":"Adduction",
            "subMain":"Normal Endpoint is 25 Degrees",
            "sub":"Post-Test ROM Measurement",
            "type":"select",
            "dbqName":"form1[0].#subform[5].TextField6[85]",
            "defaultVal":"25",
            "values":["25", "20", "15", "10", "5"],
            "answer":"25"
         },
         {
            "main":"External Rotation",
            "subMain":"Normal Endpoint is 60 Degrees",
            "sub":"Post-Test ROM Measurement",
            "type":"select",
            "dbqName":"form1[0].#subform[5].TextField6[86]",
            "defaultVal":"60",
            "values":["60", "55", "50", "45", "40", "35", "30", "25", "20", "15", "10", "5"],
            "answer":"60"
         },
         {
            "main":"Internal Rotation",
            "subMain":"Normal Endpoint is 40 Degrees",
            "sub":"Post-Test ROM Measurement",
            "type":"select",
            "dbqName":"form1[0].#subform[5].TextField6[87]",
            "defaultVal":"40",
            "values":["40", "35", "30", "25", "20", "15", "10", "5"],
            "answer":"40"
         }
      ]
   },
   {
      "question":"Which ROM exhibited pain for ##redHeading##?",
      "redHeading" : "Right Hip",
      "sub":"Check all that apply",
      "type":"radioTiles",
      "multi": true,
      "show": true,
      "small": true,
      "partial": true,
      "cols": 2,
      "questions":[
         {
            "main":"Flexion",
            "dbqName":"form1[0].#subform[6].CheckBox37[24]",
            "answer":""
         },
         {
            "main":"Extension",
            "dbqName":"form1[0].#subform[6].CheckBox37[25]",
            "answer":""
         },
         {
            "main":"Abduction",
            "dbqName":"form1[0].#subform[6].CheckBox37[28]",
            "answer":""
         },
         {
            "main":"Adduction",
            "dbqName":"form1[0].#subform[6].CheckBox37[29]",
            "answer":""
         },
         {
            "main":"External Rotation",
            "dbqName":"form1[0].#subform[6].CheckBox37[26]",
            "answer":""
         },
         {
            "main":"Internal Rotation",
            "dbqName":"form1[0].#subform[6].CheckBox37[27]",
            "answer":""
         },
         {
            "main":"None",
            "dbqName":"pass_this_question",
            "partialField": true,
            "answer":""
         }            
      ],
      "answer":""
   },
   {
      "question":"ROM Measurements After Repetitive Use Testing for ##redHeading##",
      "redHeading": "Left Hip",
      "sub":"",
      "type":"text",
      "show": true,
      "section": {
         page: "3",
         title: "RANGE OF MOTION (ROM) AND FUNCTIONAL LIMITATION REVIEW",
         number: "3A"
      },
      "questions":[
         {
            "main":"Flexion",
            "subMain":"Normal Endpoint is 125 Degrees",
            "sub":"Post-Test ROM Measurement",
            "type":"select",
            "dbqName":"form1[0].#subform[5].TextField6[88]",
            "defaultVal":"125",
            "values":["125", "120", "115", "110", "105", "100", "95", "90", "85", "80", "75", "70", "65", "60", "55", "50", "45", "40", "35", "30", "25", "20", "15", "10", "5"],
            "answer":"125"
         },
         {
            "main":"Extension",
            "subMain":"Normal Endpoint is 30 Degrees",
            "sub":"Post-Test ROM Measurement",
            "type":"select",
            "dbqName":"form1[0].#subform[5].TextField6[89]",
            "defaultVal":"30",
            "values":["30", "25", "20", "15", "10", "5"],
            "answer":"30"
         },
         {
            "main":"Abduction",
            "subMain":"Normal Endpoint is 45 Degrees",
            "sub":"Post-Test ROM Measurement",
            "type":"select",
            "dbqName":"form1[0].#subform[5].TextField6[90]",
            "defaultVal":"45",
            "values":["45", "40", "35", "30", "25", "20", "15", "10", "5"],
            "answer":"45"
         },
         {
            "main":"Adduction",
            "subMain":"Normal Endpoint is 25 Degrees",
            "sub":"Post-Test ROM Measurement",
            "type":"select",
            "dbqName":"form1[0].#subform[5].TextField6[91]",
            "defaultVal":"25",
            "values":["25", "20", "15", "10", "5"],
            "answer":"25"
         },
         {
            "main":"External Rotation",
            "subMain":"Normal Endpoint is 60 Degrees",
            "sub":"Post-Test ROM Measurement",
            "type":"select",
            "dbqName":"form1[0].#subform[5].TextField6[92]",
            "defaultVal":"60",
            "values":["60", "55", "50", "45", "40", "35", "30", "25", "20", "15", "10", "5"],
            "answer":"60"
         },
         {
            "main":"Internal Rotation",
            "subMain":"Normal Endpoint is 40 Degrees",
            "sub":"Post-Test ROM Measurement",
            "type":"select",
            "dbqName":"form1[0].#subform[5].TextField6[93]",
            "defaultVal":"40",
            "values":["40", "35", "30", "25", "20", "15", "10", "5"],
            "answer":"40"
         }
      ]
   },
   {
      "question":"Which ROM exhibited pain for ##redHeading##?",
      "redHeading" : "Left Hip",
      "sub":"Check all that apply",
      "type":"radioTiles",
      "multi": true,
      "show": true,
      "small": true,
      "partial": true,
      "cols": 2,
      "questions":[
         {
            "main":"Flexion",
            "dbqName":"form1[0].#subform[6].CheckBox37[30]",
            "answer":""
         },
         {
            "main":"Extension",
            "dbqName":"form1[0].#subform[6].CheckBox37[31]",
            "answer":""
         },
         {
            "main":"Abduction",
            "dbqName":"form1[0].#subform[6].CheckBox37[34]",
            "answer":""
         },
         {
            "main":"Adduction",
            "dbqName":"form1[0].#subform[6].CheckBox37[35]",
            "answer":""
         },
         {
            "main":"External Rotation",
            "dbqName":"form1[0].#subform[6].CheckBox37[32]",
            "answer":""
         },
         {
            "main":"Internal Rotation",
            "dbqName":"form1[0].#subform[6].CheckBox37[33]",
            "answer":""
         },
         {
            "main":"None",
            "dbqName":"pass_this_question",
            "partialField": true,
            "answer":""
         }             
      ],
      "answer":""
   },
   {
      "question":"Does a limitation in passive adduction prevent ##name## from crossing his/her legs?",
      "sub":"",
      "type":"radio",
      "show": true,
      "section": {
         page: "4",
         title: "RANGE OF MOTION (ROM) AND FUNCTIONAL LIMITATION REVIEW",
         number: "3A"
      },
      "questions":[
         {
            "label":"Right Hip",
            "title":"",
            "subMain":"",
            "sub":"",
            "options":[
               {
                  "main":"Yes",
                  "dbqName":"form1[0].#subform[6].#area[37].CheckBox37[48]",
                  "sub":""
               },
               {
                  "main":"No",
                  "dbqName":"form1[0].#subform[6].#area[37].CheckBox37[49]",
                  "sub":""
               }
            ],
            "answer":"No"
         },
         {
            "label":"Left Hip",
            "title":"",
            "subMain":"",
            "sub":"",
            "options":[
               {
                  "main":"Yes",
                  "dbqName":"form1[0].#subform[6].#area[40].CheckBox37[66]",
                  "sub":""
               },
               {
                  "main":"No",
                  "dbqName":"form1[0].#subform[6].#area[40].CheckBox37[67]",
                  "sub":""
               }
            ],
            "answer":"No"
         }
      ]
   },
   {
      "question":"Is there evidence of pain for ##redHeading##?",
      "redHeading":"Right Hip",
      "sub":"",
      "type":"radioTiles",
      "multi": true,
      "partial": true,
      "show": true,
      "small": true,
      "cols": 3,
      "section": {
         page: "4",
         title: "RANGE OF MOTION (ROM) AND FUNCTIONAL LIMITATION REVIEW",
         number: "3A"
      },
      "questions":[
         {
            "main":"Weight-bearing",
            "dbqName":"form1[0].#subform[6].CheckBox37[68],form1[0].#subform[6].#area[41].CheckBox37[75]",
            "answer":""
         },
         {
            "main":"Active motion",
            "dbqName":"form1[0].#subform[6].CheckBox37[71],form1[0].#subform[6].#area[41].CheckBox37[75]",
            "answer":""
         },
         {
            "main":"Non-weight bearing",
            "dbqName":"form1[0].#subform[6].CheckBox37[69],form1[0].#subform[6].#area[41].CheckBox37[75]",
            "answer":""
         },
         {
            "main":"Passive motion",
            "dbqName":"form1[0].#subform[6].CheckBox37[70],form1[0].#subform[6].#area[41].CheckBox37[75]",
            "answer":""
         },
         {
            "main":"On Rest/Non-movement",
            "dbqName":"form1[0].#subform[6].CheckBox37[72],form1[0].#subform[6].#area[41].CheckBox37[75]",
            "answer":""
         },
         {
            "main":"Causes functional loss",
            "dbqName":"form1[0].#subform[6].CheckBox37[73],form1[0].#subform[6].#area[41].CheckBox37[75]",
            "answer":"",
            "textarea": true,
            "maxLength":90,
            "textdbqName" : "form1[0].#subform[6].TextField6[139]",
            "placeholder": "describe in the functional loss",
            "textAnswer": ""
         },
         {
            "main":"Does not result in/cause functional loss",
            "dbqName":"form1[0].#subform[6].CheckBox37[74],form1[0].#subform[6].#area[41].CheckBox37[75]",
            "answer":""
         },
         {
            "main":"None",
            "partialField": true,
            "dbqName":"form1[0].#subform[6].#area[41].CheckBox37[76]",
            "answer":""
         }            
      ],
      "answer":""
   },
   {
      "question":"Is there evidence of pain for ##redHeading##?",
      "redHeading":"Left Hip",
      "sub":"",
      "type":"radioTiles",
      "multi": true,
      "partial": true,
      "show": true,
      "small": true,
      "cols": 3,
      "section": {
         page: "4",
         title: "RANGE OF MOTION (ROM) AND FUNCTIONAL LIMITATION REVIEW",
         number: "3A"
      },
      "questions":[
         {
            "main":"Weight-bearing",
            "dbqName":"form1[0].#subform[6].CheckBox37[77],form1[0].#subform[6].#area[42].CheckBox37[84]",
            "answer":""
         },
         {
            "main":"Active motion",
            "dbqName":"form1[0].#subform[6].CheckBox37[80],form1[0].#subform[6].#area[42].CheckBox37[84]",
            "answer":""
         },
         {
            "main":"Non-weight bearing",
            "dbqName":"form1[0].#subform[6].CheckBox37[78],form1[0].#subform[6].#area[42].CheckBox37[84]",
            "answer":""
         },
         {
            "main":"Passive motion",
            "dbqName":"form1[0].#subform[6].CheckBox37[79],form1[0].#subform[6].#area[42].CheckBox37[84]",
            "answer":""
         },
         {
            "main":"On Rest/Non-movement",
            "dbqName":"form1[0].#subform[6].CheckBox37[81],form1[0].#subform[6].#area[42].CheckBox37[84]",
            "answer":""
         },
         {
            "main":"Causes functional loss",
            "dbqName":"form1[0].#subform[6].CheckBox37[82],form1[0].#subform[6].#area[42].CheckBox37[84]",
            "answer":"",
            "textarea": true,
            "maxLength":90,
            "textdbqName" : "form1[0].#subform[6].TextField6[140]",
            "placeholder": "describe in the functional loss",
            "textAnswer": ""
         },
         {
            "main":"Does not result in/cause functional loss",
            "dbqName":"form1[0].#subform[6].CheckBox37[83],form1[0].#subform[6].#area[42].CheckBox37[84]",
            "answer":""
         },
         {
            "main":"None",
            "partialField": true,
            "dbqName":"form1[0].#subform[6].#area[42].CheckBox37[85]",
            "answer":""
         }            
      ],
      "answer":""
   },
   {
      "question":"Is there objective evidence of crepitus?",
      "sub":"",
      "type":"radio",
      "show": true,
      "section": {
         page: "5",
         title: "RANGE OF MOTION (ROM) AND FUNCTIONAL LIMITATION REVIEW",
         number: "3A"
      },
      "questions":[
         {
            "label":"Right Hip",
            "title":"",
            "subMain":"",
            "sub":"",
            "options":[
               {
                  "main":"Yes",
                  "dbqName":"form1[0].#subform[7].#area[43].CheckBox37[86]",
                  "sub":""
               },
               {
                  "main":"No",
                  "dbqName":"form1[0].#subform[7].#area[43].CheckBox37[87]",
                  "sub":""
               }
            ],
            "answer":"No"
         },
         {
            "label":"Left Hip",
            "title":"",
            "subMain":"",
            "sub":"",
            "options":[
               {
                  "main":"Yes",
                  "dbqName":"form1[0].#subform[7].#area[44].CheckBox37[88]",
                  "sub":""
               },
               {
                  "main":"No",
                  "dbqName":"form1[0].#subform[7].#area[44].CheckBox37[89]",
                  "sub":""
               }
            ],
            "answer":"No"
         }
      ]
   },
   {
      "question":"Is there objective evidence of localized tenderness or pain on palpation of the joint or associated soft tissue for ##redHeading##?",
      "redHeading":"Right Hip",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "5",
         title: "RANGE OF MOTION (ROM) AND FUNCTIONAL LIMITATION REVIEW",
         number: "3A"
      },
      "presidence":"Yes",
      "maxLength":230,
      "ref":0,
      "dbqName_yes":"form1[0].#subform[7].#area[48].CheckBox37[100]",
      "dbqName_no":"form1[0].#subform[7].#area[48].CheckBox37[101]",
      "answer":"",
      "istext": true,
      "textarea": false,
      "placeholder": "Please explain. Include location, severity, and relationship to condition(s)",
      "textdbqName":"form1[0].#subform[7].TextField6[156]",
      "textanswer":""
   },   
   {
      "question":"Is there objective evidence of localized tenderness or pain on palpation of the joint or associated soft tissue for ##redHeading##?",
      "redHeading":"Left Hip",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "5",
         title: "RANGE OF MOTION (ROM) AND FUNCTIONAL LIMITATION REVIEW",
         number: "3A"
      },
      "presidence":"Yes",
      "maxLength":230,
      "ref":0,
      "dbqName_yes":"form1[0].#subform[7].#area[49].CheckBox37[102]",
      "dbqName_no":"form1[0].#subform[7].#area[49].CheckBox37[103]",
      "answer":"",
      "istext": true,
      "textarea": false,
      "placeholder": "Please explain. Include location, severity, and relationship to condition(s)",
      "textdbqName":"form1[0].#subform[7].TextField6[155]",
      "textanswer":""
   },   
   {
      "question":"Does ##name## have malunion of femur?",
      "sub":"",
      "type":"radio",
      "multi": true,
      "show": true,
      "section": {
         page: "8",
         title: "FEMUR OR FLAIL HIP JOINT IMPAIRMENT",
         number: "6A"
      },
      "questions":[
         {
            "label":"Right Hip",
            "title":"",
            "subMain":"",
            "sub":"",
            "options":[
               {
                  "main":"Yes",
                  "dbqName":"form1[0].#subform[10].CheckBox36[161],form1[0].#subform[10].#area[66].CheckBox37[186]",
                  "sub":""
               },
               {
                  "main":"No",
                  "dbqName":"form1[0].#subform[10].#area[66].CheckBox37[187]",
                  "sub":""
               }
            ],
            "answer":"No"
         },
         {
            "label":"Left Hip",
            "title":"",
            "subMain":"",
            "sub":"",
            "options":[
               {
                  "main":"Yes",
                  "dbqName":"form1[0].#subform[10].CheckBox36[173],form1[0].#subform[10].#area[67].CheckBox37[188]",
                  "sub":""
               },
               {
                  "main":"No",
                  "dbqName":"form1[0].#subform[10].#area[67].CheckBox37[189]",
                  "sub":""
               }
            ],
            "answer":"No"
         }
      ]
   },

   {
      "question":"Indicate any surgical procedures that ##name## has had performed for ##redHeading## and provide the additional information as requested?",
      "redHeading":"Right hip",
      "sub":"",
      "type":"radioModal",
      "multi": true,
      "partial": true,
      "show": true,
      "small": true,
      "cols": 2,
      "section": {
         page: "8",
         title: "SURGICAL PROCEDURES",
         number: "7A"
      },
      "questions":[
               {
                  "main":"No surgery",
                  "dbqName":"form1[0].#subform[10].CheckBox37[194]",
                  "partialField": true,
                  "answer":"",
               },
               {
                  "main":"Hip joint resurfacing",
                  "dbqName":"form1[0].#subform[10].CheckBox37[192]",
                  "answer":"",
                  "multi": false,
                  "showSubItems": false,
                  "date1": "",
                  "dbqDate1": "form1[0].#subform[10].TextField6[205]",
               },
               {
                  "main":"Total hip joint replacement",
                  "dbqName":"form1[0].#subform[10].CheckBox37[190]",
                  "answer":"",
                  "multi": false,
                  "showSubItems": false,
                  "date1": "",
                  "dbqDate1": "form1[0].#subform[10].TextField6[207]",
                  "subItems": [
                     {
                        "main":"None",
                        "dbqName":"form1[0].#subform[10].CheckBox37[200]",
                        "colWidth": 3,
                        "answer":""
                     },
                     {
                        "main":"Markedly severe residuals of weakness, pain or limitation of motion following implantation of prosthesis",
                        "dbqName":"form1[0].#subform[10].CheckBox37[203]",
                        "colWidth": 5,
                        "answer":""
                     },
                     {
                        "main":"Moderately severe residuals of weakness, pain or limitation of motion",
                        "dbqName":"form1[0].#subform[10].CheckBox37[201]",
                        "colWidth": 4,
                        "answer":""
                     },
                     {
                        "main":"Following implantation of prosthesis with painful motion or weakness such as to require the use of crutches",
                        "dbqName":"form1[0].#subform[10].CheckBox37[204]",
                        "colWidth": 8,
                        "answer":""
                     },
                     {
                        "main":"Other",
                        "dbqName":"form1[0].#subform[10].CheckBox37[202]",
                        "colWidth": 4,
                        "subItemLinked": true,
                        "answer":""
                     }
                  ],
                  "subAnswer":"",
                  "subItemsLabel" :"Residuals",
                  "subItemOther": false,
                  "textOther": "",
                  "dbqNameOther": "form1[0].#subform[10].TextField6[209]",
                  "placeholderOther":"Other residuals describe",
               },
               {
                  "main":"Arthroscopic ligament repair",
                  "dbqName":"form1[0].#subform[10].CheckBox37[205]",
                  "answer":"",
                  "multi": false,
                  "showSubItems": false,
                  "date1": "",
                  "dbqDate1": "form1[0].#subform[10].TextField6[210]", 
                  "placeholderDate1":"Date for Surgery",                 
               },
               {
                  "main":"Other surgery",
                  "dbqName":"form1[0].#subform[10].CheckBox37[212]",
                  "answer":"",
                  "multi": false,
                  "showSubItems": false,
                  "text1": "",
                  "dbqName1": "form1[0].#subform[10].TextField6[213]",
                  "placeholder1":"Type of surgery",
                  "date1": "",
                  "dbqDate1": "form1[0].#subform[10].TextField6[214]",
               },                        
            ],
            "answer":""
   },
   {
      "question":"Indicate any surgical procedures that ##name## has had performed for ##redHeading## and provide the additional information as requested?",
      "redHeading":"Left hip",
      "sub":"",
      "type":"radioModal",
      "multi": true,
      "partial": true,
      "show": true,
      "small": true,
      "cols": 2,
      "section": {
         page: "8",
         title: "SURGICAL PROCEDURES",
         number: "7A"
      },
      "questions":[
               {
                  "main":"No surgery",
                  "dbqName":"form1[0].#subform[10].CheckBox37[195]",
                  "partialField": true,
                  "answer":"",
               },
               {
                  "main":"Hip joint resurfacing",
                  "dbqName":"form1[0].#subform[10].CheckBox37[193]",
                  "answer":"",
                  "multi": false,
                  "showSubItems": false,
                  "date1": "",
                  "dbqDate1": "form1[0].#subform[10].TextField6[206]",
                  "placeholderDate1":"Date for Surgery",
               },
               {
                  "main":"Total hip joint replacement",
                  "dbqName":"form1[0].#subform[10].CheckBox37[191]",
                  "answer":"",
                  "multi": false,
                  "showSubItems": false,
                  "date1": "",
                  "dbqDate1": "form1[0].#subform[10].TextField6[208]",
                  "placeholderDate1":"Date for Surgery",
                  "subItems": [
                     {
                        "main":"None",
                        "dbqName":"form1[0].#subform[10].CheckBox37[206]",
                        "colWidth": 3,
                        "answer":""
                     },
                     {
                        "main":"Markedly severe residuals of weakness, pain or limitation of motion following implantation of prosthesis",
                        "dbqName":"form1[0].#subform[10].CheckBox37[209]",
                        "colWidth": 5,
                        "answer":""
                     },
                     {
                        "main":"Moderately severe residuals of weakness, pain or limitation of motion",
                        "dbqName":"form1[0].#subform[10].CheckBox37[207]",
                        "colWidth": 4,
                        "answer":""
                     },
                     {
                        "main":"Following implantation of prosthesis with painful motion or weakness such as to require the use of crutches",
                        "dbqName":"form1[0].#subform[10].CheckBox37[210]",
                        "colWidth": 8,
                        "answer":""
                     },
                     {
                        "main":"Other",
                        "dbqName":"form1[0].#subform[10].CheckBox37[208]",
                        "colWidth": 4,
                        "subItemLinked": true,
                        "answer":""
                     }
                  ],
                  "subAnswer":"",
                  "subItemsLabel" :"Residuals",
                  "subItemOther": false,
                  "textOther": "",
                  "dbqNameOther": "form1[0].#subform[10].TextField6[211]",
                  "placeholderOther":"Other residuals describe",
               },
               {
                  "main":"Arthroscopic ligament repair",
                  "dbqName":"form1[0].#subform[10].CheckBox37[211]",
                  "answer":"",
                  "multi": false,
                  "showSubItems": false,
                  "date1": "",
                  "dbqDate1": "form1[0].#subform[10].TextField6[212]",                  
               },
               {
                  "main":"Other surgery",
                  "dbqName":"form1[0].#subform[10].CheckBox37[213]",
                  "answer":"",
                  "multi": false,
                  "showSubItems": false,
                  "text1": "",
                  "dbqName1": "form1[0].#subform[10].TextField6[215]",
                  "placeholder1":"Type of surgery",
                  "date1": "",
                  "dbqDate1": "form1[0].#subform[10].TextField6[216]",
                  "placeholderDate1":"Date for Surgery",
               },                        
            ],
            "answer":""
   },
   

   {
      "question":"Additional Comments",
      "sub":"",
      "optional": true,
      "type":"textarea",
      "maxLength":1030,
      "show": true,
      "section": {
         page: "10",
         title: "REMARKS",
         number: "13A"
      },
      "options":[],
      "dbqName":"form1[0].#subform[12].TextField6[225]",
      "answer":""
   }
]

export default Hip_questions;